import { createBlueprint as t } from "@made-people/blueprint";
import { o as r, p as o, s as g, a as i, b as c } from "./blueprint-1b85b4b5.mjs";
const a = t({
  slots: {
    base: "px-4 py-8 flex flex-col lg:grid lg:grid-cols-2 lg:gap-x-12",
    heading: "coo-start-1 text-heading-xs lg:text-heading-md mb-4",
    orderNumberLabel: "col-start-1 text-body-sm",
    orderNumber: "col-start-1 text-body-lg mb-4 ",
    body: "col-start-1 text-body-sm",
    cartSummary: "lg:col-start-2 row-start-1 text-heading-xs lg:text-heading-sm",
    hiddenLabel: "sr-only"
  },
  variants: {}
});
export {
  r as orderDetailsStyling,
  o as paymentDetailsStyling,
  g as successPageBarcelonaStyling,
  i as successPageMadridStyling,
  c as successPagePalmaStyling,
  a as successPageStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
